import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import BlastMessagesHeader from './BlastMessagesHeader'
import ArchiveButton from './ArchiveButton'
import css from './styles.css'
import { choosePhoneNumberFormatter } from '../../../services/formatters'

const MessagesHeader = ({
  blastMessagePatients,
  blastFilter,
  convo,
  convoTabIndex,
  handleArchiveButtonClick,
  isBlastMsg,
  isEmail,
  isLoading,
  countryCode,
}) => {
  const setHeaderText = () => {
    const formatPhoneNumber = choosePhoneNumberFormatter(countryCode)

    if (!convo) {
      return null
    }

    let patientNames = null
    if (!!convo.patients && !!convo.patients.length) {
      patientNames = convo.patients
        .map(patient => `${patient.first_name} ${patient.last_name}`)
        .join(', ')
    } else if (!isEmail) {
      patientNames = formatPhoneNumber(convo.patient_phone)
    }

    if (isEmail) {
      if (convo.subject) {
        return `${patientNames} : ${convo.subject}`
      } else if (!isLoading && !convo.subject) {
        return patientNames
      }
      return ''
    } // it's a text message convo
    return patientNames
  }

  return (
    <div className={css.wrapper}>
      {isBlastMsg ? (
        <BlastMessagesHeader
          patients={blastMessagePatients}
          blastFilter={blastFilter}
        />
      ) : (
        <span className={css.text}>{setHeaderText()}</span>
      )}
      {convo && convo.id !== -1 && (
        <ArchiveButton
          active={convo.active}
          convoId={convo.id}
          convoTabIndex={convoTabIndex}
          handleArchiveButtonClick={handleArchiveButtonClick}
        />
      )}
    </div>
  )
}

MessagesHeader.propTypes = {
  isEmail: PropTypes.bool.isRequired,
  convo: PropTypes.object,
  convoTabIndex: PropTypes.number.isRequired,
  countryCode: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isBlastMsg: PropTypes.bool.isRequired,
  blastMessagePatients: PropTypes.array.isRequired,
  blastFilter: PropTypes.string,
  handleArchiveButtonClick: PropTypes.func.isRequired,
}

const mapStateToProps = ({
  account: {
    user: { countryCode },
  },
  current: {
    conversation: {
      id: currConvoId,
      isBlastMsg,
      isEmail,
    },
  },
  conversations: {
    byId: convosById,
  },
  messages: {
    dataByConversation,
  },
  blastMessages: {
    unsent: {
      addresseeContactInfo: { patients },
    },
  },
  patientGroups: { selectedMenu },
}) => {
  const currConvo = convosById[currConvoId]
  const convoMessageMetadata = dataByConversation[currConvoId] || {}
  const blastMessagePatients = !isBlastMsg ?
    [] :
    patients
  const blastFilter = selectedMenu.id

  return {
    isEmail,
    convo: currConvo,
    countryCode,
    isLoading: !!convoMessageMetadata.isLoading,
    isBlastMsg,
    blastMessagePatients,
    blastFilter,
  }
}

export default connect(mapStateToProps)(MessagesHeader)



// WEBPACK FOOTER //
// ./src/components/Messages/Header/index.js